import React from 'react'
import ReduxToastr from 'react-redux-toastr'
import './Toastr.scss'

export const Toastr = () => (
  <ReduxToastr timeOut={3000} preventDuplicates position="bottom-right" transitionIn="fadeIn" transitionOut="fadeOut" />
)
